module.exports = __webpack_public_path__ + "static/media/spinner.1c3f175a.svg";